
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-excited",
      function () {
        return require("private-next-pages/get-excited/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-excited"])
      });
    }
  